import axios from 'axios';

const patientAxios = axios.create({
  baseURL: process.env.REACT_APP_PATIENT_ENDPOINT,
});

export default patientAxios;
